// Since these mixins are only used inside our AppData.vue instance, we can use "this" to refer to AppData.

export default {

  computed: {

    /* 
      HOWITWORKS

      This computed will redefine itself any time changes are made by the user to the filters and sorting. Either of these actions should trigger the app to reload the data in some way, so by creating a computed object for them, we can simply use $watch to react to any changes made to either of them.
    */

    ticketFiltersAndSorts () {
      return {
        filtering: this.app.pages.tickets.filtering,
        sort: this.app.pages.tickets.sort
      };
    },
    
    joinedFiltersAndSorts () {
      return {
        filtering: this.app.pages.joined.filtering,
        sort: this.app.pages.joined.sort
      }
    },

    invitedFiltersAndSorts () {
      return {
        filtering: this.app.pages.joined.filtering,
        sort: this.app.pages.invited.sort
      }
    },

    unitsFiltersAndSorts () {
      return {
        filtering: this.app.pages.units.filtering,
        sort: this.app.pages.units.sort
      }
    }

  },

  watch: {

    // List.vue is watching for list.params and list.filters value to change, and resetting the list when that happens. By updating the params on AppData.pages[page].list.params, we will get a new list.

    // Company
    '$store.getters.company' () {

      // Update anything that requires the company (eg: List Filters)
      this.app.pages.tickets.list.params.company        = this.$store.getters.company._id;
      this.app.pages.joined.list.params.company         = this.$store.getters.company._id;
      this.app.pages.invited.list.params.company        = this.$store.getters.company._id;
      this.app.pages.units.list.params.company          = this.$store.getters.company._id;
      this.app.pages.properties.list.params.company     = this.$store.getters.company._id;
      this.app.pages.roleTemplates.list.params.company  = this.$store.getters.company._id;
      this.app.pages.ticketTags.list.params.company     = this.$store.getters.company._id;
    },

    // Tickets Page
    ticketFiltersAndSorts: {

      handler () {
        this.app.pages.tickets.list.filters = this.ticketFiltersAndSorts;
      },
      deep: true // Watch changes inside sub-objects too
    },
    
    // People/Invites Pages
    joinedFiltersAndSorts: {
      handler () {
        this.app.pages.joined.list.filters = this.joinedFiltersAndSorts;

        /* 
          HOWITWORKS 
          
          Since People and Invites share filters, but use different app.page objects, we need to check the value the filter stores so we can use the $router the filter is changed to view either page (since the filter is used to switch between the two pages). This ensures the "people" tab will go to the correct page. This is also initialized when the filter are, to make sure they are consistent.  
        */

        if (this.app.navigation.people.target !== this.app.pages.joined.filtering.filters.people.value) {
          this.app.navigation.people.target = this.app.pages.joined.filtering.filters.people.value;
          
          this.$router.push({
            name: this.app.pages.joined.filtering.filters.people.value
          });
        }

      },
      deep: true
    },

    // Invites Pages
    invitedFiltersAndSorts: {
      handler () {
        this.app.pages.invited.list.filters = this.invitedFiltersAndSorts;
      },
      deep: true
    },

    // Units Page
    unitsFiltersAndSorts: {
      handler () {
        this.app.pages.units.list.filters = this.unitsFiltersAndSorts;
      },
      deep: true
    },

    'app.pages.units.filtering.filters.property.value' () {
      this.initUnitTypeFilters();
    },

    // Properties Page
    'app.pages.properties.sort': {
      handler () {
        this.app.pages.properties.list.filters = {
          sort: this.app.pages.properties.sort
        };
      },
      deep: true
    },

    // Role Templates Page
    'app.pages.roleTemplates.sort': {
      handler () {
        this.app.pages.roleTemplates.list.filters = {
          sort: this.app.pages.roleTemplates.sort
        };
      },
      deep: true
    },    
    
    // Ticket Tags Page
    'app.pages.ticketTags.sort': {
      handler () {
        this.app.pages.ticketTags.list.filters = {
          sort: this.app.pages.ticketTags.sort
        };
      },
      deep: true
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/AppData/handleFiltersAndSorts.js